// sanity.js
import { createClient } from "@sanity/client";
// Import using ESM URL imports in environments that supports it:
// import {createClient} from 'https://esm.sh/@sanity/client'

export const client = createClient({
  projectId: "lgxifnkz",
  dataset: "production",
  useCdn: true, // set to `false` to bypass the edge cache
  apiVersion: "2023-12-20", // use current date (YYYY-MM-DD) to target the latest API version
  // token: process.env.SANITY_SECRET_TOKEN // Only if you want to update content with the client
});

export async function getAuthor() {
  const posts = await client.fetch('*[_type == "author"]');
  return posts;
}

export async function getPosts() {
  const posts = await client.fetch('*[_type == "post"]');
  return posts;
}

export async function getBenefits() {
  const posts = await client.fetch('*[_type == "benefits"]');
  return posts;
}

export async function getSkills() {
  const posts = await client.fetch('*[_type == "skills"]');
  return posts;
}
export async function getProjects() {
  const posts = await client.fetch('*[_type == "projects"]');
  return posts;
}
export async function getSocials() {
  const posts = await client.fetch('*[_type == "socials"]');
  return posts;
}


